module.exports = __webpack_public_path__ + "img/ywyk-instructions02.4493c1ec.jpg";